module.exports = __webpack_public_path__ + "img/kefu.58581a4e.png";